import styled from 'styled-components';
import { AllieCard } from '../../../components/Card';
import { AllieItem } from '../../../components/Item/Item';
import { AllieText } from '../../../components/Text';

export const AllieCardStyled = styled(AllieCard)<{ selected?: boolean }>`
  box-shadow: var(--allie-shadow-md);
  transition: box-shadow 0.5s ease;
  cursor: pointer;
  margin: 0;

  &:hover {
    box-shadow: var(--allie-shadow-sm);
  }

  ${(props) =>
    props.selected &&
    `
    border: 1px solid var(--allie-color-primary-60);
  `}
`;

export const CardContent = styled.div`
  display: flex;
  align-items: top;
  column-gap: 8px;
`;

export const AllieTextStyled = styled(AllieText)`
  flex-grow: 1;

  ion-text {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const NumberCircle = styled.div<{ digits: number }>`
  width: ${(props) => Math.max(20, 16 + props.digits * 8)}px;
  height: 24px;
  border-radius: 12px;
  background-color: var(--allie-color-primary-60);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin-right: 8px;
  flex-shrink: 0;
`;

export const AllieItemStyled = styled(AllieItem)`
  --inner-padding-end: 0;
  --padding-start: 0;
  --min-height: 24px;
`;
